import { SelectOption } from "components/atoms/Select";

export { default, shiftActions, shiftSlice } from "./shiftSlice";

export interface ShiftState {
  shift: any;
  shifts: any[];
  filters: any;
  count: number;
  refresh: number;
  loading: boolean;
  current_filters: any;
  refreshLoader: boolean;
  shiftOptions: SelectOption[];
  pagination: { pageIndex: number; pageSize: number };
  driverShift: any;
  sorting: any;
  trips: any;
}

export const shiftStatusOptions = (t: any) => {
  return [
    {
      label: t("Mistake"),
      value: "Mistake",
    },
    {
      label: t("Active"),
      value: "Active",
    },
    {
      label: t("Check"),
      value: "Check",
    },
    {
      label: t("Checked"),
      value: "Checked",
    },
  ];
};
